export const labelStyle = {
  color: 'text.primary',
  fontWeight: 500,
  fontSize: 14,
  lineHeight: '20px',
  marginBottom: '4px',
  position: 'static',
  transform: 'none'
};

export const container = {
  marginTop: 0,
  width: '100%'
};

export const datePickerStyle = {
  width: '100%',
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
    backgroundColor: 'background.paper',
    height: 40
  },
  '& .MuiOutlinedInput-input': {
    padding: '8px',
    fontSize: 16,
    lineHeight: '24px',
    height: 24,
    boxSizing: 'border-box'
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'divider',
    borderWidth: 1
  },
  '& .MuiOutlinedInput-notchedOutline > legend': {
    display: 'none'
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: 'divider'
  }
};

export const helperStyle = {
  color: '#E5636D',
  paddingTop: 0.5,
  marginLeft: 0,
  fontSize: 12
};
